import React from 'react';
import { ContactCaptureBuilderView } from '../components';
export const ContactCaptureBuilderPage = () => <ContactCaptureBuilderView />;
